import { useQuery } from "@tanstack/vue-query";
import { useOfferServiceApi } from "@/composables/useOfferServiceApi";
import { useRouteParams } from "@vueuse/router";

export function useCurrentExperienceOptionsQuery() {
  const experienceId = useRouteParams("id", "");

  const query = useExperienceOptionsQuery(experienceId);

  return query;
}

export function useExperienceOptionsQuery(experienceId: MaybeRefOrGetter<string>) {
  const offerService = useOfferServiceApi();

  const query = useQuery({
    queryKey: ["experience-options", experienceId],
    queryFn: () => offerService.getExperienceOptions(toValue(experienceId)),
    enabled: computed(() => !!toValue(experienceId)),
    select: (response) => response.data,
  });

  return query;
}
